<template>
  <div>
    <div
      id="deposit"
      class="menucontent"
      v-if="showModal"
      style="overflow-y: auto; max-height: 100%"
    >
      <div
        class="inmenucontent px-2 pb-4 animate__animated animate__bounceIn"
        :style="{ backgroundImage: createBackgroundString }"
      >
        <button class="hidemenu" @click="hide">
          <i class="fas fa-times"></i>
        </button>
        <div class="ininmnct">
          <div class="menuhead"><i class="fas fa-donate"></i> เติมเงิน</div>
          <!-- <div class="depositimg">
           <img src="../../assets/banknew/icon/deposit.png">
          <video controls autoplay muted>
            <source src="video/วิดิโอวิธีการฝากเงิน.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div> -->
          <div class="headerbankdt">เลือกช่องทางการเติม</div>
          <hr class="x-hr-border-glow mb-3" />
          <div
            class="row m-0"
            v-if="shouldShowIframe"
            style="overflow: hidden; width: 100%; height: 950px"
          >
            <div class="headerwarning-text">
              <p>คำเตือน!!! หากไม่ปฏิบัติตามกฏท่านจะไม่ได้รับเครดิตเงินฝาก</p>
            </div>
            <div class="warning-text">
              <ul>
                <li>ห้ามนำ QRCODE นี้กลับมาใช้ซ้ำ</li>
                <li>ห้ามทำรายการหากเกินเวลาที่กำหนด ให้กดรับQRCODEใหม่</li>
                <li>ห้ามกด QRCODE หลายๆรอบโดยไม่ทำการฝาก</li>
              </ul>
            </div>
            <iframe
              :src="iframeSrc"
              frameborder="0"
              style="width: 100%; height: 100%; overflow: hidden"
            ></iframe>
          </div>
          <div class="row m-0" v-else>
            <div class="col-3 p-0 leftdps">
              <div
                class="nav flex-column nav-pills"
                id="v-pills-tab"
                role="tablist"
                aria-orientation="vertical"
              >
                <a
                  v-if="this.scb"
                  class="nav-link active"
                  id="v-pills-home-tab"
                  data-toggle="pill"
                  href="#v-pills-home"
                  role="tab"
                  aria-controls="v-pills-home"
                  aria-selected="true"
                  ><img
                    class="banktabicon"
                    src="../../assets/icon/bankicon.png?v=2"
                  />
                  ธนาคาร</a
                >
                <a
                  class="nav-link"
                  id="v-pills-qrcode-tab"
                  data-toggle="pill"
                  href="#v-pills-qrcode"
                  role="tab"
                  aria-controls="v-pills-qrcode"
                  aria-selected="false"
                  v-if="gatewayp.depstatus == 1"
                  ><img class="banktabicon" src="../../assets/bank/tq.webp" />
                  พร้อมเพย์</a
                >
                <a
                  class="nav-link"
                  id="v-pills-profile-tab"
                  data-toggle="pill"
                  href="#v-pills-profile"
                  role="tab"
                  aria-controls="v-pills-profile"
                  aria-selected="false"
                  v-if="twn.status == 1"
                  ><img
                    class="banktabicon"
                    src="../../assets/banknew/truewallet.svg?v=1"
                  />
                  TrueWallet</a
                >
              </div>
            </div>
            <div class="col-9 p-0">
              <div class="tab-content" id="v-pills-tabContent">
                <div
                  class="tab-pane fade active show"
                  id="v-pills-home"
                  role="tabpanel"
                  aria-labelledby="v-pills-home-tab"
                  v-if="Auth.bank != 'truewallet'"
                >
                  <div class="griddps">
                    <div class="ingriddps" v-if="scb.showbank == 1">
                      <div class="iningriddps copybtn">
                        <img src="../../assets/bank/scb.svg" /> <br />
                        ธนาคาร{{ scb.name }} <br />
                        <span id="scb_number">
                          {{ changeBankNumber(scb.number) }}
                        </span>
                        <br />
                        <span> {{ scb.fullname }}</span>
                        <br />
                        <button
                          @click="onclickCopyScb()"
                          id="copy_scb"
                          v-if="Auth.bank != 'truewallet'"
                        >
                          <i class="fad fa-copy"></i> คัดลอก
                        </button>
                        <!-- <button @click="regisBank()" id="copy_scb" v-else>
                          ลงทะเบียน
                        </button> -->
                      </div>
                    </div>
                    <div class="ingriddps" v-if="scb3.showbank == 1">
                      <div class="iningriddps copybtn">
                        <img src="../../assets/bank/scb.svg" /> <br />
                        ธนาคาร{{ scb3.name }} <br />
                        <span id="scb_number">
                          {{ changeBankNumber(scb3.number) }}
                        </span>
                        <br />
                        <span> {{ scb3.fullname }}</span>
                        <br />
                        <button
                          @click="onclickCopyScb3()"
                          id="copy_scb"
                          v-if="Auth.bank != 'truewallet'"
                        >
                          <i class="fad fa-copy"></i> คัดลอก
                        </button>
                        <!-- <button @click="regisBank()" id="copy_scb" v-else>
                          ลงทะเบียน
                        </button> -->
                      </div>
                    </div>
                    <div class="ingriddps" v-if="scb5.showbank == 1">
                      <div class="iningriddps copybtn">
                        <img src="../../assets/bank/scb.svg" /> <br />
                        ธนาคาร{{ scb5.name }} <br />
                        <span id="scb_number">
                          {{ changeBankNumber(scb5.number) }}
                        </span>
                        <br />
                        <span> {{ scb5.fullname }}</span>
                        <br />
                        <button
                          @click="onclickCopyScb5()"
                          id="copy_scb"
                          v-if="Auth.bank != 'truewallet'"
                        >
                          <i class="fad fa-copy"></i> คัดลอก
                        </button>
                        <!-- <button @click="regisBank()" id="copy_scb" v-else>
                          ลงทะเบียน
                        </button> -->
                      </div>
                    </div>
                    <div class="ingriddps" v-if="kbank.status == 1">
                      <div class="iningriddps copybtn">
                        <img src="../../assets/bank/kbank.svg" /> <br />
                        ธนาคาร{{ kbank.name }} <br />
                        <span id="scb_number">
                          {{ changeBankNumber(kbank.number) }}
                        </span>
                        <br />
                        <span> {{ kbank.fullname }} </span>
                        <br />
                        <button
                          @click="onclickCopykbank()"
                          id="copy_kbank"
                          v-if="Auth.bank != 'truewallet'"
                        >
                          <i class="fad fa-copy"></i> คัดลอก
                        </button>
                        <button
                          @click="regisBank('bank')"
                          id="copy_kbank"
                          v-else
                        >
                          <!-- <i class="fad fa-copy"></i> -->
                          ลงทะเบียน
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    class="d-flex justify-content-center align-items-center mt-2"
                    style="
                      font-size: 14px;
                      color: #ff2e2e;
                      margin-right: -15px;
                      margin-left: 10px;
                    "
                  >
                    ห้ามฝากเงินจากบัญชีทรูวอเลตเข้าธนาคาร <br />
                    **เด็ดขาด** ไม่สามารถทำรายการคืนเงินได้<br />
                    **กรุณาใช้บัญชีที่สมัครโอนมาเท่านั้น<br />
                    หากใช้บัญชีอื่นโอนมาจะไม่ทำรายการให้ไม่ว่าจะกรณีใดๆ**
                  </div>
                </div>
                <div
                  class="tab-pane fade active show"
                  id="v-pills-home"
                  role="tabpanel"
                  aria-labelledby="v-pills-home-tab"
                  v-else
                >
                  <div
                    class="ingridregis"
                    style="position: relative; top: 107px"
                  >
                    <div class="iningridregis copybtn">
                      <button @click="regisBank('bank')" id="copy_kbank">
                        <!-- <i class="fad fa-copy"></i> -->
                        ลงทะเบียนเดี๋ยวนี้
                      </button>
                      <br />
                      <span class="text-danger" style="font-size: 1rem"
                        >*** ท่านยังไม่ได้ลงทะเบียน <br />
                        บัญชีธนาคารเพื่อฝาก-ถอน</span
                      >
                      <br />
                    </div>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="v-pills-profile"
                  role="tabpanel"
                  aria-labelledby="v-pills-profile-tab"
                >
                  <div class="griddps">
                    <div class="ingriddps">
                      <div class="iningriddps copybtn">
                        <img src="../../assets/banknew/truewallet.svg?v=1" />
                        <br />
                        {{ twn.name }} <br />
                        <span id="scb_number">
                          {{ changePhoneNumber(twn.number) }}
                        </span>
                        <br />
                        <span> {{ twn.fullname }}</span>
                        <br />
                        <button @click="onclickCopyTmw()" id="copy_scb">
                          <i class="fad fa-copy"></i> คัดลอก
                        </button>
                        <!-- <button
                          @click="regisBank('truemoney')"
                          id="copy_scb"
                          v-else
                        >
                          ลงทะเบียน
                        </button> -->
                      </div>
                    </div>
                  </div>
                  <!-- <div
                  class="row d-flex justify-content-center align-items-center"
                  style="height: 180px"
                >
                  ทรูมันนี่วอลเล็ทปิดปรับปรุงชั่วคราว
                </div> -->
                  <div
                    class="d-flex justify-content-center align-items-center mt-2"
                    style="
                      font-size: 14px;
                      color: #ff2e2e;
                      margin-right: -15px;
                      margin-left: 10px;
                    "
                  >
                    **กรุณาใช้บัญชีที่สมัครโอนมาเท่านั้น
                    หากใช้บัญชีอื่นโอนมาจะไม่ทำรายการให้ไม่ว่าจะกรณีใดๆ**
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="v-pills-qrcode"
                  role="tabpanel"
                  aria-labelledby="v-pills-qrcode-tab"
                >
                  <div>
                    <div class="ingriddps">
                      <div class="iningriddpsqr copybtn">
                        <div class="row">
                          <div class="col-12 d-flex justify-content-center">
                            <div
                              class=""
                              ref="homeCont"
                              style="
                                width: 265px;
                                height: 320px;
                                border: solid;
                                border-radius: 11px;
                                background-color: white;
                                border-color: #ffe18c;
                              "
                            >
                              <img
                                alt="โปรโมชั่น Welcome Back ยินดีต้อนรับกลับ"
                                :style="{ width: '256px' }"
                                width="260"
                                src="@/assets/images/ppheader.png"
                              />
                              <span
                                class="text-muted"
                                style="
                                  font-weight: 600;
                                  font-size: 25px;
                                  position: relative;
                                  top: 27px;
                                "
                                >กรุณาระบุยอด <br />ทำรายการฝาก</span
                              >
                              <br />
                              <img
                                alt="โปรโมชั่น Welcome Back ยินดีต้อนรับกลับ"
                                :style="{ width: '70px', marginTop: '45px' }"
                                src="@/assets/images/arrowdowngif.gif"
                              />
                            </div>
                          </div>
                          <br />
                        </div>
                        <input
                          placeholder="ใส่จำนวนเงิน(100฿ขึ้นไป)"
                          type="text"
                          id="credit_withdraw size1"
                          v-model="amount"
                          class="form-control text-center p-0 py-2 mt-3 mb-3 fad"
                          style="
                            font-size: 1.2em !important;
                            font-weight: 400;
                            width: 80%;
                            position: relative;
                          "
                          pattern="[0-9]*"
                          inputmode="numeric"
                        />
                        <button @click="onclickGenarateQR()" :disabled="isGeneratingQR">
                          <i class="fad fa-qrcode mr-1" v-if="!isGeneratingQR"></i>
                      <span
                        v-if="!isGeneratingQR"
                        style="
                          color: white;
                          text-align: center;
                          font-size: 15px;
                          font-weight: 300;
                        "
                        >รับ QR Code</span
                      >
                      <span
                        v-else
                        style="
                          color: white;
                          text-align: center;
                          font-size: 15px;
                          font-weight: 300;
                        "
                        ><i class="fas fa-spinner fa-spin"></i> กำลังสร้าง QR
                        Code...</span
                      >
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="overlaymenu"></div>
    </div>
    <div id="code_pro" class="menucontent" v-if="showModalRegis">
      <div
        class="inmenucontent animate__animated animate__bounceIn"
        :style="{ backgroundImage: createBackgroundString }"
      >
        <button class="hidemenu" @click="hideRegis">
          <i class="fas fa-times"></i>
        </button>
        <div class="ininmnct px-3">
          <div class="menuhead mb-3"><i class="fas fa-code"></i> ลงทะเบียน</div>
          <div class="depositimg">
            <img src="./../../assets/moneyback.png" />
          </div>
          <div class="animate__animated animate__flipInX">
            <div class="form-group">
              <div>
                <!-- <label>ท่านต้องการใช้ธนาคาร หรือ ทรูมันนี่วอลเล็ท</label> -->
                <div class="el-input my-1">
                  <i class="fad fa-university"></i>
                  <select class="inputstyle" v-model="BankSelect">
                    <option selected value="">-- เลือก --</option>
                    <option value="bank">ธนาคาร</option>
                    <!-- <option value="truewallet">ทรูมันนี่วอลเล็ท</option> -->
                  </select>
                </div>
              </div>
            </div>
            <div
              class="form-group"
              id="s_bank_form"
              v-if="BankSelect === 'bank'"
            >
              <div>
                <label>เลือกธนาคาร</label>
                <div class="el-input my-1">
                  <i class="fad fa-university"></i>
                  <select class="inputstyle" v-model="FormBank.bank">
                    <option selected value="">-- เลือกธนาคาร --</option>
                    <option value="กรุงเทพ">ธนาคารกรุงเทพ จำกัด (มหาชน)</option>
                    <option value="กสิกรไทย">
                      ธนาคารกสิกรไทย จำกัด (มหาชน)
                    </option>
                    <option value="กรุงไทย">ธนาคารกรุงไทย จำกัด (มหาชน)</option>
                    <option value="ทหารไทยธนชาต">
                      ธนาคารทหารไทยธนชาต จำกัด (มหาชน)
                    </option>
                    <option value="ไทยพาณิชย์">
                      ธนาคารไทยพาณิชย์ จำกัด (มหาชน)
                    </option>
                    <option value="ซิตี้แบงค์">
                      ธนาคารซิตี้แบงก์ เอ็น.เอ.
                    </option>
                    <option value="แสตนดาร์ดชาร์เตอร์">
                      ธนาคารสแตนดาร์ดชาร์เตอร์ด (ไทย) จำกัด (มหาชน)
                    </option>
                    <option value="ซีไอเอ็มบีไทย">
                      ธนาคารซีไอเอ็มบี ไทย จำกัด (มหาชน)
                    </option>
                    <option value="ยูโอบี">ธนาคารยูโอบี จำกัด (มหาชน)</option>
                    <option value="กรุงศรีฯ">
                      ธนาคารกรุงศรีอยุธยา จำกัด (มหาชน)
                    </option>
                    <option value="ออมสิน">ธนาคารออมสิน</option>
                    <option value="ธอส">ธนาคารอาคารสงเคราะห์</option>
                    <option value="ธกส">
                      ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร
                    </option>
                    <option value="อิสลาม">ธนาคารอิสลามแห่งประเทศไทย</option>
                    <option value="ทิสโก้">ธนาคารทิสโก้ จำกัด (มหาชน)</option>
                    <option value="เกียรตินาคินภัทร">
                      ธนาคารเกียรตินาคินภัทร จำกัด (มหาชน)
                    </option>
                    <option value="ไอซีบีซี">
                      ธนาคารไอซีบีซี (ไทย) จำกัด (มหาชน)
                    </option>
                    <option value="ไทยเครดิต">
                      ธนาคารไทยเครดิต เพื่อรายย่อย จำกัด (มหาชน)
                    </option>
                    <option value="LHBANK">
                      ธนาคารแลนด์ แอนด์ เฮ้าส์ จำกัด (มหาชน)
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="BankSelect === 'bank'">
              <div>
                <label>เลขบัญชีธนาคาร</label>
                <div class="el-input my-1">
                  <i class="fas fa-lock"></i>
                  <input
                    type="text"
                    placeholder="เลขบัญชีธนาคาร"
                    autofocus="autofocus"
                    autocomplete="on"
                    inputmode="numeric"
                    v-model="FormBank.number"
                    onkeypress="return event.charCode != 32"
                    oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');"
                    class="inputstyle"
                  />
                </div>
              </div>
            </div>
            <button
              type="button"
              class="loginbtn mt-0 mb-3"
              @click="onSubmitRegisBank"
            >
              <span> ยืนยัน </span>
            </button>
            <div class="text-center">
              แหล่งหา Code กิจกรรม
              <a target="_blank" style="color: gold"><u>รายละเอียด</u></a>
            </div>
          </div>
        </div>
      </div>
      <div class="overlaymenu"></div>
    </div>
  </div>
</template>

<script>
import { HTTP } from "@/services/http-common";
import { mixin as VueTimers } from "vue-timers";
import { mapGetters } from "vuex";

var moment = require("moment");
export default {
  name: "deposit-component",
  timers: {
    updateTime: { time: 1000, autostart: false, repeat: true },
  },
  mixins: [VueTimers],
  data() {
    return {
      showModal: false,
      showModalRegis: false,
      scb: [],
      scb3: [],
      scb5: [],
      kbank: [],
      twn: [],
      target: null,
      amount: "",
      showQR: false,
      amountDis: false,
      remaining_secs: null,
      ends_at: null,
      FormBank: {
        bank: "",
        number: "",
      },
      BankSelect: "",
      ref: "",
      qrCodeUrl: "",
      timeLeft: 300,
      countdownTimer: null,
      showCountdown: false,
      iframeSrc: "",
      isGeneratingQR: false,
    };
  },
  // mounted() {
  //   this.start();
  // },
  methods: {
    show() {
      this.fetchBankDeposit();
      // Reset the iframeSrc and timer as needed.
      this.iframeSrc = "";
      // Reset timeLeft or other states as necessary.
      this.timeLeft = 300;
    },
    hide() {
      this.showModal = false;
    },
    hideRegis() {
      this.showModalRegis = false;
    },
    onclickGenarateQR() {
      this.genarateQR();
      this.isGeneratingQR = true;
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
      this.timeLeft = 300; // Reset time to 5 minutes
      this.showCountdown = true; // Show countdown text
      this.countdownTimer = setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft--;
        } else {
          this.showCountdown = false;
          clearInterval(this.countdownTimer);
        }
      }, 1000);
    },
    genarateQR() {
      let homeCont = this.$refs.homeCont;
      let loader = this.$loading.show({
        container: homeCont,
        loader: "Dots",
        color: "red",
        opacity: 0,
        // backgroundColor: "#000000",
      });
      HTTP.post(
        `member/gatewaypay`,
        {
          amount: this.amount,
          phone: this.Auth.phone,
          fname: this.Auth.fname,
          lname: this.Auth.lname,
          banknumber: this.Auth.banknumber,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("lb_token"),
          },
        }
      )
        .then((response) => {
          if (response.data.data) {
            // Extract UUID and construct the direct QR code image URL
            // this.qrCodeUrl = `https://api.vpayth.com/storage/prompt_pay/${uuidMatch[1]}.png`;

            // this.qrCodeUrl = response.data.data;
            // window.open(this.qrCodeUrl, "_blank").focus();
            this.iframeSrc = response.data.data;
            this.isGeneratingQR = false;
          } else {
            this.$toast.error(
              response.data.msg != undefined
                ? response.data.msg
                : "ทำรายการไม่สำร็จ โปรดทำรายการอีกครั้ง"
            );
            loader.hide();
            this.isGeneratingQR = false;
          }
        })
        .catch((err) => {
          this.$toast.error(
            err.data.msg != undefined
              ? err.data.msg
              : "ไม่สามารถโหลดข้อมูลธนาคารได้ กรุณาลองใหม่"
          );
        })
        .then(() => {
          loader.hide();
        });
    },
    openQRCodeUrl() {
      if (this.qrCodeUrl) {
        window.open(this.qrCodeUrl, "_blank").focus();
      } else {
        // Optionally, handle the case where qrCodeUrl is not set
        alert(
          "QR Code URL is not available. Please generate the QR code first."
        );
      }
    },
    beforeDestroy() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
    },
    fetchUserProfile() {
      HTTP.get(`member/profile`)
        .then((resp) => {
          if (resp.data.status != undefined && !resp.data.status) {
            this.$toast.error(
              resp.data.msg != undefined
                ? resp.data.msg
                : "ไม่สามารถโหลดข้อมูลโปรไฟล์ได้ กรุณาลองใหม่"
            );
          } else {
            if (resp.data.status != undefined && resp.data.status) {
              this.$store.dispatch("saveProfile", resp.data.data);
            }
          }
        })
        .catch((err) => {
          this.$toast.error(
            err.data.msg != undefined
              ? err.data.msg
              : "ไม่สามารถโหลดข้อมูลโปรไฟล์ได้ กรุณาเข้าสู่ระบบใหม่อีกครั้ง"
          );
        });
    },
    onSubmitRegisBank() {
      if (this.FormBank.bank != "" && this.FormBank.number != "") {
        HTTP.post(`member/update?bank`, {
          bank_name: this.FormBank.bank,
          bank_number: this.FormBank.number,
        })
          .then((resp) => {
            if (resp.data.status != undefined && !resp.data.status) {
              this.$toast.error(
                resp.data.msg != undefined
                  ? resp.data.msg
                  : "ไม่สามารถทำรายการได้ กรุณาลองใหม่"
              );
            } else {
              this.$toast.success("ลงทะเบียนสำเร็จ");
              this.showModal = false;
              this.showModalRegis = false;
              this.fetchUserProfile();
            }
          })
          .catch((err) => {
            this.$toast.error(
              err.data.msg != undefined
                ? err.data.msg
                : "ไม่สามารถทำรายการได้ กรุณาลองใหม่"
            );
          });
      } else {
        this.$toast.error("ข้อมูลไม่ครบถ้วน");
      }
    },
    fetchBankDeposit() {
      HTTP.get(`system/bank`)
        .then((resp) => {
          if (resp.data.status != undefined && !resp.data.status) {
            this.$toast.error(
              resp.data.msg != undefined
                ? resp.data.msg
                : "ไม่สามารถโหลดข้อมูลธนาคารได้ กรุณาลองใหม่"
            );
          } else {
            this.scb = resp.data.data[0];
            this.scb3 = resp.data.data[1];
            this.scb5 = resp.data.data[2];
            this.kbank = resp.data.data[3];
            this.twn = resp.data.data[4];
            this.gatewayp = resp.data.data[5];
            this.showModal = true;
          }
        })
        .catch((err) => {
          this.$toast.error(
            err.data.msg != undefined
              ? err.data.msg
              : "ไม่สามารถโหลดข้อมูลธนาคารได้ กรุณาลองใหม่"
          );
        });
    },
    copyToClipboard(textToCopy) {
      //et textToCopy = document.getElementById("rgb").textContent;

      console.log(textToCopy);
      // text area method
      let textArea = document.createElement("textarea");
      textArea.value = textToCopy;
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      return new Promise((res, rej) => {
        document.execCommand("copy") ? res() : rej();
        this.$toast.success("คัดลอกสำเร็จ");
        textArea.remove();
      });
    },
    onclickCopyScb() {
      this.copyToClipboard(this.scb.number);
    },
    onclickCopyScb3() {
      this.copyToClipboard(this.scb3.number);
    },
    onclickCopyScb5() {
      this.copyToClipboard(this.scb5.number);
    },
    onclickCopykbank() {
      this.copyToClipboard(this.kbank.number);
    },
    onclickCopyTmw() {
      this.copyToClipboard(this.twn.number);
    },
    changeBankNumber(number) {
      if (number) {
        const set1 = number.substring(0, 3);
        const set2 = number.substring(3, 9);
        const set3 = number.substring(9, 10);
        const sum = `${set1}-${set2}-${set3}`;
        return sum;
      }
    },
    changePhoneNumber(number) {
      if (number) {
        const set1 = number.substring(0, 3);
        const set2 = number.substring(3, 7);
        const set3 = number.substring(7, 10);
        const sum = `${set1}-${set2}-${set3}`;
        return sum;
      }
    },

    updateTime: function () {
      const now = moment();
      const ends = moment(this.ends_at);
      const duration = moment.duration(ends.diff(now));

      this.remaining_secs = Math.floor(duration.asSeconds());
      if (this.remaining_secs == 0) {
        this.amountDis = false;
        this.showQR = false;
      }
    },

    regisBank(bank) {
      this.BankSelect = bank;
      this.showModalRegis = true;
      this.showModal = false;
    },
  },

  computed: {
    ...mapGetters(["Auth"]),
    ...mapGetters(["WebSetting"]),
    createBackgroundString() {
      return `linear-gradient(140deg, ${this.WebSetting.color1}, #000000 95%), linear-gradient(180deg, #a78059 -30%, #f2d7a9 22%, #715236 72%, #f1bb73 112%)`;
    },
    remaining: function () {
      if (!this.remaining_secs) {
        return "5mins";
      }
      const duration = moment.duration(this.remaining_secs, "seconds");

      const mins = duration.minutes();
      const secs = duration.seconds();

      return mins ? `${mins}: ${secs} นาที` : `${secs}secs`;
    },
    shouldShowIframe() {
      // Show the iframe if iframeSrc is not empty and timeLeft is within 5 minutes.
      return this.iframeSrc !== "" && this.timeLeft > 0;
    },
  },
};
</script>

<style>
.warning-text {
  color: #ff0000; /* Red color for warning messages */
  font-size: 15px; /* Adjust size as needed */
  font-weight: bold;
  text-align: left;
  /* Other styles as needed */
}
.headerwarning-text {
  color: #ff0000; /* Red color for warning messages */
  font-size: 15px; /* Adjust size as needed */
  font-weight: bold;
  text-align: center;
  margin-top: 10px; /* Add some space at the top */
  /* Other styles as needed */
}
</style>
